import { EventEmitter } from 'eventemitter3';
if (!window.__CN_UTILS_EVENTINSTANCE__) {
    window.__CN_UTILS_EVENTINSTANCE__ = new EventEmitter();
}
export const events = window.__CN_UTILS_EVENTINSTANCE__;
